import React, { Component } from 'react';

import {Form, Field, TreeSelect, Checklist, Authenticate} from '../Form/Form.js';
import { Formik } from 'formik';
import * as Yup from 'yup';

class UserCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        roles: [],
        permissions: [],
        currentPassword: ""
      },
      permissions: [],
      roles: [],
      rolesKey: [].toString(),
      stage: "one",
      verificationLink: "",
      qrsrc: "",
      code_input: "",
      loading: true
    }
  }

  componentDidMount(){
    Promise.all([this.getGroups(), this.getRoles()])
      .then((results) => this.setState({loading: false}));
  }

  getRoles = () => {
    return fetch('/api/getRoles', {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(r =>  r.json().then(data => ({res: r, body: data})))
    .then(obj => {
      if(!obj.res.ok) throw Error(obj.res.statusText);
      else{
        if(obj.body === undefined || obj.body === null) console.log("No Roles to display");
        else {
          this.setState({roles: obj.body, rolesKey: obj.body.toString()});
        }
      }

    })
    .catch(function(error) {
      console.log(error);
    })
  }

  getGroups = () => {
    return fetch('/api/getAvailableGroups', {
      method: "POST",
      //body: JSON.stringify({username: this.state.initialValues.username}),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(r =>  r.json().then(data => ({res: r, body: data})))
    .then(obj => {
      if(!obj.res.ok) throw Error(obj.res.statusText);
      else{
        if(obj.body === undefined || obj.body === null) console.log("No Groups to display");
        else {
          let tree = this.buildGroupsTree(obj.body);
          let state = this.buildDropdownStateFromTree(tree);
          this.setState({permissions: state});
        }
      }

    })
    .catch(function(error) {
      console.log(error);
    })
  }

  buildGroupsTree = (groups) => {
    let tree = {};
    groups.forEach((group) => {
      let curTree = tree;
      let components = group.dn.split(',').reverse();
      components
        .map((component) => component.split('=')[1])
        .forEach((nodeName, i) => {
          if (!curTree[nodeName])
            curTree[nodeName] = {}
          curTree = curTree[nodeName]

          if (i === components.length - 1) {
            curTree.checked = group.checked;
            curTree.value = group.dn;
          } else {
            if (!curTree.children)
              curTree.children = {};
            curTree = curTree.children;
          }
        })
    })

    return tree;
  }

  buildDropdownStateFromTree = (tree, checked) => {
    let state = [];
    for (let key in tree) {
      let newNode = {};
      newNode.label = key;
      newNode.value = tree[key].value;
      newNode.checked = tree[key].checked || checked;
      newNode.children = this.buildDropdownStateFromTree(tree[key].children, newNode.checked);
      state.push(newNode);

      if (newNode.checked) {
        let initialValues = this.state.initialValues;
        initialValues.permissions.push(newNode.value)
        this.setState({initialValues: initialValues});
      }
    }
    return state;
  }

  submit = (values, actions) => {
    fetch(
      '/api/createUser',
      {
        method: "POST",
        body: JSON.stringify(values),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (res.ok) {
        res.json()
          .then(({ link }) => {
            this.setState({ stage: 'two', verificationLink: link })
          });
      } else {
        if (res.status === 401) {
          alert("Incorrect Password");
        } else if (res.status === 400) {
          res.json().then(errors => actions.setErrors(errors));
        } else {
          alert("Could not create user");
        }
      }
    })
    .then(() => actions.setSubmitting(false));
  }

  validationSchema = () => {
    return Yup.object()
      .shape({
        currentPassword: Yup.string().ensure()
          .required('Required')
          .max(128, "Too long!"),
        username: Yup.string().ensure()
          .required('Required!')
          .min(1, 'Too short!')
          .max(128, 'Too long!')
          .matches(/^[A-Za-z_]+\d*$/, "Please enter a valid username!"),
        firstName: Yup.string().ensure()
          .required('Required!')
          .min(2, 'Too short!')
          .max(30, 'Too long!')
          .matches(/^[a-zA-Z]+(-[a-zA-Z]+)?$/, "Please enter a valid first name!"),
        lastName: Yup.string().ensure()
          .required('Required!')
          .min(2, 'Too short!')
          .max(30, 'Too long!')
          .matches(/^[a-zA-Z]+(-[a-zA-Z]+)?$/, "Please enter a valid last name!"),
        email: Yup.string().ensure()
          .required('Required!')
          .email("Please enter a valid email!"),
      })
  }

  render() {
    if(this.state.stage === "two"){
      return(
        <div>
          <h2 className="form-title">User Verification Link</h2>
          <p>
            Click on the link below if you want to verify the user on your current machine, otherwise the verification link below has been emailed to the user.
          </p>
          <p style={{textAlign: "center"}}>
            <a href={this.state.verificationLink} target="_blank">Verification Link</a>
          </p>
          <div className="form-group">
            <div className="col-md-4"></div>
            <div className="col-md-4"><button type="button" className="btn btn-light" onClick={() => this.props.changeView("userManagement") }>Done</button></div>
            <div className="col-md-4"></div>
          </div>
          <div className="col-md-1"></div>
        </div>
      );
    } else {
      return (
        <Formik initialValues={this.state.initialValues} onSubmit={this.submit} validationSchema={this.validationSchema()}>
          {
            ({values, touched, errors, dirty, isValid, isSubmitting, handleChange, handleBlur, handleSubmit, handleReset, setFieldValue, setFieldError, setFieldTouched}) => {
              const propsForField = {values, touched, errors, handleChange, handleBlur, setFieldValue, setFieldError, setFieldTouched, dirty};
              return (
                <Form title="Create New User" onSubmit={handleSubmit} isLoading={isSubmitting || this.state.loading}>
                  <Field id="username" fieldName="Username" {...propsForField} />

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <Field id="email" type="email" fieldName="Email" {...propsForField} />
                  <Field id="firstName" fieldName="First Name" {...propsForField} />
                  <Field id="lastName" fieldName="Last Name" {...propsForField} />

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <Checklist key={this.state.rolesKey} label="Roles" data={this.state.roles} {...propsForField}/>

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <TreeSelect data={this.state.permissions} {...propsForField} />

                  <Authenticate id="currentPassword" initialValues={this.state.initialValues} {...propsForField} />

                  <div className="form-group">
                    <label className="col-md-4 control-label"></label>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary" disabled={!dirty}>Create User</button>
                        </div>
                        <div className="col-md-6">
                          <button type="button" className="btn btn-light" onClick={() => this.props.changeView("sites")}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') &&
                    <pre>
                      {`${JSON.stringify(values, null, 2)}\n\n`}
                      {`${JSON.stringify(errors, null, 2)}`}
                    </pre>
                  }
                </Form>
              );
            }
          }
        </Formik>
      );
    }
  }
}

export default UserCreate;



// WEBPACK FOOTER //
// ./src/Components/userCreate/UserCreate.js